import React from 'react';
import PropTypes from 'prop-types';
import MediaQuery from 'react-responsive';

import Overlay from './Overlay';
import Sidebar from './Sidebar';
import { MAX_DISPLAY_WIDTH } from './constants';

import './style.scss';

const SidebarWrapper = ({ teams }) => (
    <MediaQuery maxWidth={MAX_DISPLAY_WIDTH}>
        <div className="header-sidebar-wrapper">
            <Sidebar teams={teams} />
            <Overlay />
        </div>
    </MediaQuery>
);

SidebarWrapper.propTypes = {
    teams: PropTypes.array,
};

export default SidebarWrapper;
